// New Stripe reconciliation page — renders the shared ReconWorkspace with the Stripe config.
// Parallel to the existing StripeReconciliationPage (untouched); surfaced as "… (New)" in the menu
// during transition. See docs/recon-workspace-design.md.
import React from 'react';
import ReconWorkspace from '../../components/recon/ReconWorkspace';
import stripeConfig from '../../config/recon/stripe';

export default function StripeReconciliationNewPage() {
  return <ReconWorkspace config={stripeConfig} />;
}
